import React from 'react';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link, useParams } from 'react-router-dom';

import AccueilAssistantsDeploiement from './AccueilAssistantsDeploiement';
import AssistantDeploiementPage from './AssistantDeploiementPage';
import { assistantsDeploiement, obtenirAssistantDeploiement } from './assistantsDeploiement';

function DeploiementsPage() {
  const { assistantId } = useParams();
  const isMobile = window.innerHeight > window.innerWidth;
  const assistant = assistantId ? obtenirAssistantDeploiement(assistantId) : null;

  const rendreContenu = () => {
    if (!assistantId) {
      return <AccueilAssistantsDeploiement assistants={assistantsDeploiement} />;
    }

    if (!assistant || assistant.statut !== 'disponible') {
      return (
        <Paper style={{ padding: 16 }}>
          <Typography variant="h5">Assistant introuvable</Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
            L assistant demande n est pas disponible dans le registre des deploiements.
          </Typography>
          <Button component={Link} to="/Ingenierie/Deploiements" variant="outlined" style={{ marginTop: 16 }}>
            Retour aux assistants
          </Button>
        </Paper>
      );
    }

    return <AssistantDeploiementPage assistant={assistant} />;
  };

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      {rendreContenu()}
    </Container>
  );
}

export default DeploiementsPage;



// WEBPACK FOOTER //
// src/components/deploiements/DeploiementsPage.js